import script from "./VisionModule5.vue?vue&type=script&setup=true&lang=js"
export * from "./VisionModule5.vue?vue&type=script&setup=true&lang=js"

import "./VisionModule5.vue?vue&type=style&index=0&id=0c1e1764&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c1e1764"]])

export default __exports__